<script setup>
defineProps({
  path: { type: String, required: true },
  viewbox: {
    type: String,
    default: '0 0 24 24',
  },
})
</script>

<template>
  <svg
    version="1.1"
    :viewBox="viewbox"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <rect
      x="0"
      y="0"
      width="24"
      height="24"
      style="fill: none"
    />
    <path
      :d="path"
      class="fill-current"
    />
  </svg>
</template>
